module.exports = __webpack_public_path__ + "f6f62baadd20779a449cae10b73caea9.svg";